import { getFromLocalStorage } from './localStorage';

export const countryDetailsFromStorage = () => getFromLocalStorage('country_details') ?? {};

export const countryCodesFunc = () => {
  const countryCodes = getFromLocalStorage('onboarded_country_codes')
    ? getFromLocalStorage('onboarded_country_codes') ?? {}
    : {
        Russia: 'RU',
      };

  return countryCodes;
};

export const CountryCodes = countryCodesFunc();

export const countryCodeUrlsFunc = () => {
  const countryCodeUrls = getFromLocalStorage('onboarded_country_code_urls')
    ? getFromLocalStorage('onboarded_country_code_urls') ?? {}
    : {
        RU: '/ru/',
      };

  return countryCodeUrls;
};

export const CountryCodeUrls = countryCodeUrlsFunc();

/**
 * Extracts a region subtag from the browser's locale, e.g. 'en-AU' -> 'AU',
 * 'ru-RU' -> 'RU'. Returns undefined for locales with no region (e.g. 'en').
 */
const getBrowserCountryCode = (): string | undefined => {
  const locale = navigator.language || navigator.languages?.[0] || '';
  return locale.split('-')[1]?.toUpperCase();
};

export const getDefaultCountryCode = () => {
  const loginCountryUrl = getFromLocalStorage('login_country_url');
  if (loginCountryUrl) {
    return loginCountryUrl;
  }

  // Otherwise guess from the browser's locale, matched against the countries
  // already onboarded in this browser (e.g. a returning user whose session
  // expired) — re-read fresh rather than the module-load-time CountryCodeUrls
  // constant, since onboarding data may have loaded since then. Only falls
  // back to the hardcoded Russia default when nothing matches.
  const browserCountryCode = getBrowserCountryCode();
  const onboardedCountryCodeUrls = countryCodeUrlsFunc();
  if (browserCountryCode && onboardedCountryCodeUrls[browserCountryCode]) {
    return onboardedCountryCodeUrls[browserCountryCode];
  }

  return CountryCodeUrls[CountryCodes.Russia];
};

export const getExactCountryCodeFromRoute = () => {
  const country = countryDetailsFromStorage();
  return country.country_url;
};

export const isUrlHavingCountryCode = () =>
  window.location.pathname.includes('superadmin') || getExactCountryCodeFromRoute();

export const getCountryCodeFromRoute = () => {
  const country = countryDetailsFromStorage();
  return country.country_url;
};

export const getCountryCode = () => {
  const country = countryDetailsFromStorage();
  return country.country_code ?? CountryCodes.Russia;
};

export const getCountryName = () => {
  const country = countryDetailsFromStorage();
  return country.name;
};

export const getCountryModal = () => {
  const country = countryDetailsFromStorage();
  return country.modal_type;
};
